import { action, makeObservable, observable } from 'mobx';
import { Notify } from '@shared/ui-native/Notify';
import { Ajax2 } from '@shared/Ajax';
import { isTabInFocus } from '@shared/utils/utils';
import { PageStateUtils } from '@shared/user-state/PageStateUtils';

interface IMarineVessel {
    mmsi: number;
    geometry: {
        type: string;
        coordinates: number[];
    }
    properties: Record<string, string | number>
}

export class MarineStore {
    @observable.ref items: IMarineVessel[] = [];
    @observable.ref previousItems: IMarineVessel[] = []; // to draw direction/trail
    @observable showOnMap: boolean = false;
    @observable isDoingAsyncWork: boolean = false;
    private projectCenter: { lat: number, lon: number } = null;
    pollTimer = null;

    constructor() {
        makeObservable(this);
    }

    toggleShow = () => {
        this.showOnMap = !this.showOnMap;

        if (this.showOnMap) {
            this.enable();
        } else {
            this.clear();
        }
    }

    fetchVessels = async () => {
        if (!kuura.hasAisIntegrationEnabled()) return;

        this.isDoingAsyncWork = true;

        if (!this.projectCenter) {
            const center = await Ajax2({
                url: 'api/ajax_project_center_point.json',
            })
            this.projectCenter = center.centerPoint;
        }

        return Ajax2({
            url: 'https://meri.digitraffic.fi/api/ais/v1/locations',
            data: {
                from: +moment().subtract(24, 'hours'),
                latitude: this.projectCenter.lat,
                longitude: this.projectCenter.lon,
                radius: 100,
            }
        })
        .then(resp => {
            //resp.features.forEach(f => {
            //    f.geometry.coordinates[0] += (Math.random() * 0.1);
            //    f.geometry.coordinates[1] += (Math.random() * 0.1);
            //})
            this.previousItems = this.items;
            this.items = resp.features;
        })
        .catch(() => {
            Notify.error();
        })
        .finally(() => this.isDoingAsyncWork = false);
    }

    enable = () => {
        this.showOnMap = true;
        this.fetchVessels();
        this.pollTimer = setInterval(() => {
            if (isTabInFocus()) {
                this.fetchVessels();
            }
        }, 10 * 60 * 1000);
    }

    clear = () => {
        this.showOnMap = false;
        this.items = [];
        clearInterval(this.pollTimer);
    }

    stateful = {
        defaultState: {
            showOnMap: false
        },

        getCurrentState: (): any => {
            return {
                showOnMap: this.showOnMap
            };
        },

        restoreDefaultState: (): void => {
            this.stateful.restoreState(this.stateful.defaultState);
        },

        restoreState: action((state?: any): void => {
            if (!state) return null;

            if (PageStateUtils.stateHasKey<any>(state, 'showOnMap')) {
                this.showOnMap = state.showOnMap;
                if (this.showOnMap) {
                    this.enable();
                } else {
                    this.clear();
                }
            }
        })
    };
}
